// extracted by mini-css-extract-plugin
module.exports = {"test":"style_test__34BqB","noData":"style_noData__dpBHR"};